import React, { useContext, useEffect } from "react";
import { css } from "emotion";
import OverviewCard from "../OverviewCard";
import { GlobalContext } from "../../context/GlobalState";
import workspaces from "../../services/api/workspaces";
import CircleAddButton from "../CircleAddButton";
import { boxStyles, textSizes, colors } from "../../styles/theme";
import NewSpotlightButton from "./NewSpotlightButton";
import NoSpotlight from "../../assets/images/empty-states/no-spotlight.svg";

const OverviewList = () => {
  const { currentWorkspace, spotlights, setSpotlights } = useContext(
    GlobalContext
  );

  const getUpdatedSpotlights = async () => {
    try {
      let { data: spotlights } = await workspaces.getSpotlights(
        currentWorkspace
      );

      const activeSpotlight = spotlights.filter((spotlight) => {
        return spotlight.isActive;
      });

      let inactiveSpotlights = spotlights.filter((spotlight) => {
        return !spotlight.isActive;
      });

      inactiveSpotlights = inactiveSpotlights.sort((a, b) => {
        return b.createdAt - a.createdAt;
      });

      spotlights = activeSpotlight.concat(inactiveSpotlights);

      setSpotlights(spotlights || []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUpdatedSpotlights();
  }, []);

  return (
    <>
      {spotlights && spotlights.length > 0 ? (
        spotlights.map((spotlight) => (
          <OverviewCard key={spotlight.id} spotlight={spotlight} />
        ))
      ) : (
        <div className={emptyMessage}>
          <img src={NoSpotlight} alt="No spotlights"/>
          <h4>Create a spotlight to get started.</h4>
          <p className="subtitle">Spotlights are no-code audio and video messages you can easily embed on your website.</p>
          <NewSpotlightButton />
        </div>
      )}
    </>
  );
};

export default OverviewList;
const emptyMessage = css`
  width: 100%;
  padding: ${boxStyles.standardPadding};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  
  img {
    margin-top: 30px;
  }
  
  h4 {
    margin-bottom: 10px;
    margin-top: 40px;
  }
  
  p {
    font-size: ${textSizes.intermediate};
    color: ${colors.subtitleColor};
    padding-horizontal: 10px;
    
    &.subtitle {
        margin-bottom: 30px;
    }
  }
  
  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    width: 50%;
    margin: auto;
  }
`;
